<div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
    <div>
        <button routerLink="add" class="btn btn-primary">
            Add Company
        </button>
    </div>
  <div *ngIf="companies && companies.length">
    <h1 class="text-xm text-nowrap text-left">Showing {{(50 * currentPage) - (companies != 50? (50
        -companies.length) : 0) }} of {{totalResults }} entries
      </h1> 
     </div>
  <div class="relative">
      <input type="text"  [(ngModel)]="search" required placeholder="search.." class="pl-8" />
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
          <path stroke-linecap="round" stroke-linejoin="round"
              d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
      </svg>
  </div>
</div>
<div>
  <div class="overflow-x-auto mt-4">
      <table class="min-w-full table-auto border-collapse border  border-zinc-950/10 dark:border-white/10">
          <thead class="bg-zinc-950/5 dark:bg-white/5">
              <tr>
                  <th
                      class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                      Name</th>
                  <th
                      class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                      Address</th>
                  <th
                      class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                      Contact No.</th>
                  <th
                      class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                      Created At</th>
                  <th
                      class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                      Updated At</th>
                  <th
                      class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                      Drivers</th>
                  <th
                      class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                      Vehicles</th>
                  <th
                      class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                  </th>
              </tr>
          </thead>
          <tbody>
            <tr *ngFor="let company of companies | filter: search | paginate: { itemsPerPage: numberOfRecords, currentPage: currentPage, totalItems:totalResults }">
                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10">
                  <div>
                    <div class="text-sm-dark text-nowrap">{{company.transportationCompanyName}}</div>
                    <div class="text-nowrap">{{ company.email || 'N/A' }}</div>
                  </div>
                </td>
                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                  {{ company.address?.name }}
                </td>
                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                  {{ company.phoneNumber }}
                </td>
                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                  {{ company.createdAt }}
                </td>
                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                  {{ company.updatedAt }}
                </td>
                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                  {{ company.drivers}}
                </td>
                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                  {{ company.fleet }}
                </td>
                <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                  <div class="flex justify-start gap-2">
                    <a routerLink="{{company.id}}">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                        <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                      </svg>
                    </a>
                    <button class="border-l border-zinc-300 px-2">
                        <a routerLink="{{company.id}}/edit">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5 text-zinc-500 dark:text-zinc-400">
                        <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                      </svg>
                    </a>
                    </button>
                  </div>
                </td>
              </tr>
              
          </tbody>
      </table>
  </div>
</div>
<div class="fixed bottom-0 inset-x-0 flex justify-end bg-zinc-100 dark:bg-zinc-900">
    <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
  </div>